"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.time = time;
exports.duration = duration;
function time() {
    return process.hrtime.bigint();
}
function duration(start, stop) {
    return Number(stop - start) / 1000000;
}
//# sourceMappingURL=time.js.map